import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// boot debug helper (public/index.html inline script)
try {
  if (typeof window !== 'undefined' && window.__BOOT_DEBUG__ && typeof window.__BOOT_DEBUG__.markReady === 'function') {
    window.__BOOT_DEBUG__.markReady();
  }
} catch (e) {}

// PWA: Service Worker 등록 (설치/standalone 동작을 위해 필요)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // ✅ 운영 포함: SW 등록을 비활성화하고(캐시 문제 원천 차단), 기존 SW/캐시를 정리합니다.
    // - 증상: "일반 새로고침=옛버전, Ctrl+F5=최신" (특히 runtime-config / index.html 변경 시)
    // - 해결: SW unregister + caches 삭제
    navigator.serviceWorker.getRegistrations()
      .then((regs) => Promise.all((regs || []).map((r) => r.unregister())))
      .catch(() => {});

    if (window.caches && typeof window.caches.keys === 'function') {
      window.caches.keys()
        .then((keys) => Promise.all((keys || []).map((k) => {
          // CRA/Workbox 캐시 포함하여 전부 삭제(운영 안정성 우선)
          return window.caches.delete(k);
        })))
        .catch(() => {});
    }
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
